import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { BiExitFullscreen, BiFullscreen } from 'react-icons/bi';
import { Container, ControlsWrap, Title, Separator, ViewModeRow, FiltersRow } from './styles';

import { TypeReport } from '../types';
import PeriodFilter from './PeriodFilter';
import ViewModeFilter from './ViewModeFilter';
import ButtonExport from './ButtonExport';

type HeaderProps = {
  disableExport: boolean;
  isLoadingExcel: boolean;
  typeReport: TypeReport;
  setTypeReport: Dispatch<SetStateAction<TypeReport>>;
  dataValue: number;
  setDataValue: Dispatch<SetStateAction<number>>;
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  exportExcel: () => void;
};

const Header: React.FC<HeaderProps> = ({
  disableExport,
  isLoadingExcel,
  typeReport,
  setTypeReport,
  dataValue,
  setDataValue,
  showModal,
  setShowModal,
  exportExcel,
}) => {
  const [titleReport, setTitleReport] = useState<string>('Histórico de consumo');

  useEffect(() => {
    if (typeReport === 'graph') {
      setTitleReport('Histórico de consumo');
    } else if (typeReport === 'list') {
      setTitleReport('Histórico de boletos');
    }
  }, [typeReport]);

  return (
    <Container>
      <Title>{titleReport}</Title>
      <ControlsWrap>
        <ViewModeRow>
          <ViewModeFilter typeReport={typeReport} setTypeReport={setTypeReport} />
        </ViewModeRow>
        <Separator />
        <FiltersRow>
          <PeriodFilter dataValue={dataValue} setDataValue={setDataValue} />
          <ButtonExport
            disabled={typeReport === 'list' || disableExport}
            onClick={exportExcel}
            isLoadingExcel={isLoadingExcel}
          />
        </FiltersRow>
      </ControlsWrap>
      {showModal ? (
        <BiExitFullscreen onClick={() => setShowModal((prev) => !prev)} />
      ) : (
        <BiFullscreen onClick={() => setShowModal((prev) => !prev)} />
      )}
    </Container>
  );
};

export default Header;
